import { ElementOf } from "ts-essentials";

export type Bucket = ElementOf<typeof BucketValues>;
export const BucketValues = ["tech.holibob.vault", "tech.holibob.images.public"] as const;
